import dataService from 'services/dataService';
import { API_PATIENTS_ORDER_CONSUMABLES } from 'services/dataService/resources';

const orderConsumable = {
  state: {},
  reducers: {
    setDischarge: (state, payload) => ({
      ...state,
      ...payload,
    }),
  },
  effects: () => ({
    async submit(postData) {
      const { error, data } = await dataService.createOne(
        API_PATIENTS_ORDER_CONSUMABLES,
        postData,
      );
      return { error, data };
    },
  }),
};

export default orderConsumable;
